import { FC, useState } from 'react';
import { AnvilSelect, FilterButton, SingleOptionProps } from '@servicetitan/design-system';

import * as Styles from './multi-value-filter.module.less';
import { SCROLL_HEIGHT } from '../../../utils/ux';

interface MultiValueFilterProps {
    label: string;
    loading?: boolean;
    options: SingleOptionProps[];
    appliedValues: SingleOptionProps['value'][];
    onApply: (selectedValues: SingleOptionProps['value']) => void;
}

export const MultiValueFilter: FC<MultiValueFilterProps> = ({
    onApply,
    options,
    appliedValues,
    loading,
    label,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [selectedValues, setSelectedValues] = useState<SingleOptionProps['value'][]>([]);

    const onClose = () => {
        setIsOpen(false);
    };

    const onOpen = () => {
        setIsTouched(false);
        setSelectedValues(appliedValues);
        setIsOpen(true);
    };

    const toggle = () => {
        (isOpen ? onClose : onOpen)();
    };

    const apply = () => {
        if (isTouched) {
            onApply(selectedValues);
        }
        onClose();
    };

    const handleChange = (selectedOptions: SingleOptionProps[]) => {
        if (!options.length) {
            return;
        }

        setIsTouched(true);
        setSelectedValues(selectedOptions.map(({ value }) => value));
    };

    return (
        <AnvilSelect
            width="s"
            loading={loading}
            options={options}
            multiple={{
                selectAll: true,
            }}
            onOpenChange={toggle}
            value={selectedValues}
            onChange={handleChange}
            footer={{
                actionName: 'Apply',
                onActionClick: apply,
                className: isTouched ? undefined : Styles.disabled,
            }}
            scrollHeight={SCROLL_HEIGHT}
            trigger={
                <FilterButton
                    label={label}
                    onClick={toggle}
                    expandIcon={isOpen}
                    value={appliedValues.length > 0 && appliedValues.length}
                />
            }
        />
    );
};
